////////LIBRARY/////////
import { createSelector } from 'reselect'
import { find, reduce } from 'lodash'

const getUser = (state) => state.user.identity
const getUserKiosks = (state) => state.user.identity.userKiosks
const getKioskSelected = (state) => state.user.identity.kioskSelected
const getTableReferential = (state) => state.user.tableReferential

export const selectIdsUser = createSelector([getUser, getKioskSelected], (user, idKiosk) => {
	return {
		userId: user.id,
		idKiosk: idKiosk,
		idStore: user.idCompanyTyped,
		idDistributors: user.idDistributor,
		jwt: user.jwttoken,
		idUserLanguage: user.preferedLanguage,
		company: user.company,
		kioskPool: user.kiosksPool,
		kiosksPoolSelectedIds: reduce(
			user.kioskSelected,
			(result, value) => {
				result.push(value.id)
				return result
			},
			[]
		),
	}
})

export const selectKioskSelected = createSelector([getUser, getKioskSelected], (user, idKiosk) => find(user.userKiosks, ['idKiosk', idKiosk]))
export const selectUserId = createSelector([getUser], (user) => user.id)
export const selectKioskStatus = createSelector([getKioskSelected, getUserKiosks], (kioskSelected, kiosksList) => {
	let userStatusSelected = find(kiosksList, { idKiosk: kioskSelected })
	return {
		printIntegrity: userStatusSelected.printerIntegrity,
		bankFlowIntegrity: userStatusSelected.bankFlowIntegrity,
		simCardIntegrity: userStatusSelected.simCardIntegrity,
		otherIntegrity: userStatusSelected.otherIntegrity,
		globalIntegrity: userStatusSelected.globalIntegrity,
	}
})

export const selectTableReferential = createSelector([getTableReferential], (user) => user.tableReferential)
